import React, { useEffect, useState } from 'react'
import {
  CBadge,
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CSmartTable,
} from '@coreui/react-pro'

import GradeService from 'src/service/GradeService'
import ToastComponent from 'src/components/common/TaostComponent.js'

const API_URL = process.env.REACT_APP_API_URL

const columns = [
  { label: 'Team Code', key: 'sn', _style: { width: '25%' } },
  { label: 'Team', key: 'team_name' },
  { label: 'Status', key: 'is_active', _style: { width: '20%' } },
]

// Read-only list of the teams sitting under one comp, opened from the "Teams" count on the
// comps listing. Same table styling as the Players listing so both read the same way.
const TeamsModal = ({ grade, visible, onClose }) => {
  const [teams, setTeams] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!visible || !grade?.id) return undefined

    let cancelled = false
    setTeams([])
    setLoading(true)
    GradeService.getGradeTeams(grade.id)
      .then((res) => {
        if (cancelled) return
        if (res.status === 200) {
          setTeams(res.data || [])
        } else {
          ToastComponent(res.message || 'Unable to load teams.', 'error')
        }
      })
      .catch(() => {
        if (!cancelled) ToastComponent('Unable to load teams.', 'error')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [visible, grade?.id])

  return (
    <CModal visible={visible} onClose={onClose} size="lg" alignment="center">
      <CModalHeader>
        <CModalTitle>Teams in {grade?.grade}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <div className="ge-datatable ge-datatable--static">
          <CSmartTable
            columns={columns}
            items={teams}
            itemsPerPage={10}
            loading={loading}
            pagination={teams.length > 10}
            noItemsLabel="No teams are linked to this comp yet."
            scopedColumns={{
              team_name: (item) => (
                <td>
                  <div className="d-flex align-items-center">
                    <img
                      src={
                        item.image
                          ? `${API_URL}uploads/team_sponsor/${item.image}`
                          : `${API_URL}uploads/game_logo/${item.game_logo}`
                      }
                      alt="team"
                      width="40"
                      height="40"
                      className="rounded me-2"
                    />
                    <div className="fw-semibold">{item.team_name}</div>
                  </div>
                </td>
              ),
              is_active: (item) => (
                <td>
                  {item.is_active === 1 ? (
                    <CBadge color="success">Active</CBadge>
                  ) : (
                    <CBadge color="secondary">Inactive</CBadge>
                  )}
                </td>
              ),
            }}
            tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
          />
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default TeamsModal
